import { useQueryStartCalling } from "@/hooks/queries/use-query-start-calling";

export const useFetchDataStartCallingModal = useQueryStartCalling;
